import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  ModalHeader,
  Input,
} from "reactstrap";
import { loadClients } from "../../actions/clientActions";
import { loadLocations } from "../../actions/locationActions";
import { mustBeArray } from "../../utils";
import If from "../Common/If";
import LinkClientList from "./LinkClientList";
import LinkLocationList from "./LinkLocationList";

const LinkClientAndLocation = (props) => {
  const {
    isModalOpen,
    handleSave,
    handleCancel,
    dispatch,
    locations,
    clients,
    title,
    hasClientUserRole,
    selectedClients,
    selectedLocations,
  } = props;
  const [name, setName] = useState("");
  const [selectedClientLocation, setSelectedClientLocation] = useState({
    id: null,
    type: null,
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [clientListLoading, setClientListLoading] = useState(true);
  const [locationListLoading, setLocationListLoading] = useState(true);

  const handleSearch = () => {
    setSearchLoading(true);
    loadData(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      loadData(false);
    }
  }, [isModalOpen]);

  const handleClear = () => {
    setName("");
    loadData(true);
  };

  const loadData = (clear) => {
    dispatch(loadLocations(name, clear, true)).then(() => {
      setLocationListLoading(false);
      setSearchLoading(false);
    });
    if (hasClientUserRole) {
      dispatch(loadClients(name, clear, false, null, true)).then(() => {
        setClientListLoading(false); 
        setSearchLoading(false);
      });
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleSelection = ({ id, type }) => {
    setSelectedClientLocation({ id, type });
  };

  const handleClientLocationSave = () => {
    if (!selectedClientLocation.id) {
      toastr.error(
        `Please select a ${hasClientUserRole ? "client or" : ""} location`
      );
    }
    handleSave(selectedClientLocation);
  };

  const filteredClients = useMemo(() => {
    const tempClients = selectedClients.reduce((a, b) => {
      return [...a, b.toClientId];
    }, []);
    return clients.filter((o) => !tempClients.includes(o.id));
  }, [clients, selectedClients]);

  const filteredLocations = useMemo(() => {
    const tempLocations = selectedLocations.reduce((a, b) => {
      return [...a, b.toLocationId];
    }, []);
    return locations.filter((o) => !tempLocations.includes(o.id));
  }, [locations, selectedLocations]);

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={handleCancel}
      centered
      style={{ maxWidth: "800px" }}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <form
          className="form-horizontal"
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <div className="form-group row mb-2">
            <div className="col-4">
              <Input
                type="text"
                value={name}
                name="name"
                onChange={handleNameChange}
                placeholder="Name"
              />
            </div>
            <div className="col-5">
              <button type="Submit" className="btn btn-primary">
                <i className="fa fa-search" />
                &nbsp;Search
              </button>
              <button className="btn btn-default ml-1" onClick={handleClear}>
                Clear
              </button>
            </div>
          </div>
        </form>
        <If
          condition={hasClientUserRole}
          then={
            <LinkClientList
              data={filteredClients}
              selectedClientLocation={selectedClientLocation}
              className="mb-2"
              loading={clientListLoading}
              handleSelection={handleSelection}
            />
          }
        />

        <LinkLocationList
          data={filteredLocations}
          selectedClientLocation={selectedClientLocation}
          loading={locationListLoading}
          handleSelection={handleSelection}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClientLocationSave} color="success">
          Save
        </Button>
        &nbsp;
        <Button onClick={handleCancel}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    locations: mustBeArray(state.locations && state.locations.items),
    clients: mustBeArray(state.clients && state.clients.items),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkClientAndLocation);
